import { render, staticRenderFns } from "./HeaderTranslateButtons.vue?vue&type=template&id=760ae458&scoped=true"
import script from "./HeaderTranslateButtons.vue?vue&type=script&lang=ts"
export * from "./HeaderTranslateButtons.vue?vue&type=script&lang=ts"
import style0 from "./HeaderTranslateButtons.vue?vue&type=style&index=0&id=760ae458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760ae458",
  null
  
)

export default component.exports